import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";

import mockData from "./data";
import { useMediaQuery } from "@material-ui/core";
import theme from "theme";
import { useSelector } from "react-redux";
import { ListPaymentTable } from "./components";

const useStyles = makeStyles((theme) => ({
  
  root: {
    padding: theme.spacing(3),
  },
  rootSmall: {
    padding:0,
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

const ListPayment = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);

  const [reloadPage, setReloadpage] = useState(false);
  function reloadFunction() {
    setReloadpage(!reloadPage);  
  }

  const [data] = useState(mockData);
 


  const [idSel, setIdSelDialog] = useState("0");

  function handleIdChange(newId) {
    setIdSelDialog(newId);
  }

  const [DataSel, setDataSel] = useState([]);
  
  function SelectData(newData) {
    setDataSel(newData);
  }

  return (
    <div className={isSmall?classes.rootSmall: classes.root}>








      {/* <ShipmentToolbar  /> */}
      <div className={classes.content}>
        <ListPaymentTable
          ChangeId={handleIdChange}
          data={data}
          selData={SelectData}
          reload={reloadPage}
          reloadFunc={reloadFunction}


        />
      </div>
    </div>
  );
};

export default ListPayment;
